import { curry, compose, isEmpty, reduce, path, equals, filter, values } from 'ramda'

import { FieldConfig, FieldsOrdering } from 'App/duck/types'

/**
 * getFieldsBy :: (String, Object) -> Object
 *
 * get fields by type from fieldsConfig
 */
export const getFieldsBy = curry((type, fieldsConfig) =>
  fieldsConfig.filter((fields) => equals(type, path(['type', 'name'], fields))),
)
/**
 * getFieldsOrderingOf :: (String, Object) -> String[]
 *
 * get fields order of type from fieldsOrdering
 */
export const getFieldsOrderingOf = curry((type, fieldsOrdering) => values(fieldsOrdering[type]))

/**
 * getFieldsInOrderBy :: (String, Object, Object) -> Object[]
 *
 * get fields by type from fieldsConfig in order from fieldsOrdering
 */
export const getFieldsInOrderBy = curry(
  (type: string, fieldsConfig: FieldConfig[], fieldsOrdering: FieldsOrdering) =>
    reduce((acc: FieldConfig[], name) => {
      const filteredAttributeByName = filter(compose(equals(name), path(['attribute'])))(
        getFieldsBy(type, fieldsConfig),
      ) as FieldConfig[]

      if (isEmpty(filteredAttributeByName)) {
        return acc
      }

      return acc.concat(filteredAttributeByName)
    }, [])(getFieldsOrderingOf(type, fieldsOrdering)),
)
